/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'error-page';
const componentName = 'error-page-profile-preview';
const prefix = `${moduleName}.${componentName}`;

export const errorPageIndexPosition = `${prefix}.errorPageIndexPosition`;

export const ENGLISH = {
    [errorPageIndexPosition]: 'Error Page Index Position',
};
